"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _DragHandle = _interopRequireDefault(require("@insided/deprecated-preact-components/control/DragHandle"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _ExternalLink = _interopRequireDefault(require("@insided/shared/icons/ExternalLink"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

// Too much files to change
var FeaturedTopic = function FeaturedTopic(_ref) {
  var title = _ref.title,
      url = _ref.url,
      onDelete = _ref.onDelete,
      _ref$isSortable = _ref.isSortable,
      isSortable = _ref$isSortable === void 0 ? true : _ref$isSortable,
      newStyle = _ref.newStyle;

  if (newStyle) {
    return (0, _preact.h)("div", {
      className: "widget-configuration_sortable-deletable-item-list"
    }, (0, _preact.h)("div", {
      className: "widget-configuration_sortable-item__info"
    }, isSortable && (0, _preact.h)(_DragHandle.default, null), (0, _preact.h)("p", {
      className: "sortable-item_title"
    }, title), (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(url),
      target: "_blank",
      rel: "noreferrer",
      className: "featured-topic__link widget-configuration_sortable-item__link"
    }, (0, _preact.h)(_ExternalLink.default, {
      height: 16,
      width: 16
    }))), (0, _preact.h)(_buttonControl.default, {
      className: "widget-configuration_sortable-item__remove-btn",
      title: "Remove",
      variant: "warning",
      onClick: onDelete,
      icon: (0, _preact.h)(_Close.default, {
        width: 16,
        height: 16
      })
    }));
  }

  return (0, _preact.h)("div", {
    className: "featured-topic__item"
  }, (0, _preact.h)("div", {
    className: "featured-topic__info"
  }, isSortable && (0, _preact.h)(_DragHandle.default, null), (0, _preact.h)("p", {
    className: "featured-topic__title"
  }, title), (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    target: "_blank",
    rel: "noreferrer",
    className: "featured-topic__link"
  }, (0, _preact.h)(_ExternalLink.default, {
    height: 16,
    width: 16
  }))), (0, _preact.h)(_buttonControl.default, {
    title: "Remove",
    variant: "warning",
    onClick: onDelete
  }));
};

var _default = FeaturedTopic;
exports.default = _default;